import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-4 relative"
}
const _hoisted_2 = { class: "tooltip-new" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h6", { style: {"flex":"1"} }, "How do I provide liquidity?", -1)
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "text-gray-200 text-sm" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-1" }, "Farm", -1)
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_9 = {
  key: 1,
  class: "mt-4"
}

import { configService } from '@/services/config/config.service';
import FarmDepositForm from '@/embr/components/pages/farm/FarmDepositForm.vue';
import FarmWithdrawForm from '@/embr/components/pages/farm/FarmWithdrawForm.vue';
import useWeb3 from '@/services/web3/useWeb3';
import { useRoute } from 'vue-router';
import { ref, onMounted, computed } from 'vue';
import useTokens from '@/composables/useTokens';
import { PoolTransactionsTab } from '@/components/contextual/pages/pool/PoolTransactionsCard/types';
import BalTabs from '@/components/_global/BalTabs/BalTabs.vue';
import SuccessOverlay from '@/components/cards/SuccessOverlay.vue';
import TutorialLiquidityTooltip from '@/components/tooltips/TutorialLiquidityTooltip';

type Props = {
  tokenAddress: string;
  farmId: string;
  hasUnstakedBpt: boolean;
  hasFarmRewards: boolean;
};


export default _defineComponent({
  props: {
    tokenAddress: { type: String, required: true },
    farmId: { type: String, required: true },
    hasUnstakedBpt: { type: Boolean, required: true },
    hasFarmRewards: { type: Boolean, required: true }
  } as unknown as undefined,
  setup(__props: {
  tokenAddress: string;
  farmId: string;
  hasUnstakedBpt: boolean;
  hasFarmRewards: boolean;
}) {

const props = __props


/**
 * STATE
 */
const { network } = configService;
const { explorerLinks: explorer, appNetworkConfig } = useWeb3();
const route = useRoute();

const { tokens, loading, injectTokens, dynamicDataLoading } = useTokens();

const farmInvestmentSuccess = ref(false);
const farmWithdrawalSuccess = ref(false);
const txHash = ref('');

function handleFarmInvestment(txReceipt): void {
  farmInvestmentSuccess.value = true;
  txHash.value = txReceipt.hash;
}

function handleFarmWithdrawal(txReceipt): void {
  farmWithdrawalSuccess.value = true;
  txHash.value = txReceipt.hash;
}

const tabs = [
  { value: 'deposit', label: 'Deposit' },
  { value: 'withdraw', label: 'Withdraw' }
];

const activeTab = ref(tabs[0].value);

return (_ctx: any,_cache: any) => {
  const _component_BalAlert = _resolveComponent("BalAlert")!
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!farmInvestmentSuccess.value && !farmWithdrawalSuccess.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!_unref(loading) && props.hasUnstakedBpt)
            ? (_openBlock(), _createBlock(_component_BalAlert, {
                key: 0,
                title: "You have unstaked MPT in your wallet",
                description: "If you deposit your MPT into the farm, you will earn additional rewards paid out in MOND.",
                type: "warning",
                size: "sm",
                class: "mb-3 unstaked-wpt-alert"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_unref(TutorialLiquidityTooltip))
          ]),
          (_unref(loading) || _unref(dynamicDataLoading))
            ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                key: 1,
                class: "h-96"
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, " Stake your " + _toDisplayString(_unref(tokens)[props.tokenAddress].symbol === 'MPT-50-50-MOND-VLX'
            ? 'MPT-80-20-MOND-VLX'
            : _unref(tokens)[props.tokenAddress].symbol) + " to earn MOND ", 1),
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(BalTabs, {
                    modelValue: activeTab.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = $event)),
                    tabs: tabs,
                    "no-pad": "",
                    class: "-mb-px",
                    rounded: true
                  }, null, 8, ["modelValue"])
                ]),
                (activeTab.value === 'deposit')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(FarmDepositForm, {
                        "token-address": props.tokenAddress,
                        "farm-id": props.farmId,
                        onSuccess: _cache[1] || (_cache[1] = ($event: any) => (handleFarmInvestment($event)))
                      }, null, 8, ["token-address", "farm-id"])
                    ]))
                  : _createCommentVNode("", true),
                (activeTab.value === 'withdraw')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(FarmWithdrawForm, {
                        "token-address": props.tokenAddress,
                        "farm-id": props.farmId,
                        onSuccess: _cache[2] || (_cache[2] = ($event: any) => (handleFarmWithdrawal($event)))
                      }, null, 8, ["token-address", "farm-id"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (farmInvestmentSuccess.value)
        ? (_openBlock(), _createBlock(SuccessOverlay, {
            key: 0,
            title: _ctx.$t('farmDepositSettled'),
            description: _ctx.$t('farmDepositSuccess'),
            closeLabel: _ctx.$t('close'),
            explorerLink: _unref(explorer).txLink(txHash.value),
            onClose: _cache[3] || (_cache[3] = ($event: any) => (farmInvestmentSuccess.value = false)),
            class: "h-96"
          }, null, 8, ["title", "description", "closeLabel", "explorerLink"]))
        : _createCommentVNode("", true),
      (farmWithdrawalSuccess.value)
        ? (_openBlock(), _createBlock(SuccessOverlay, {
            key: 1,
            title: _ctx.$t('farmWithdrawalSettled'),
            description: _ctx.$t('farmWithdrawalSuccess'),
            closeLabel: _ctx.$t('close'),
            explorerLink: _unref(explorer).txLink(txHash.value),
            onClose: _cache[4] || (_cache[4] = ($event: any) => (farmWithdrawalSuccess.value = false))
          }, null, 8, ["title", "description", "closeLabel", "explorerLink"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})